import { useSearch } from "@tanstack/react-router";
import { AllSkillsView } from "@/components/discovery/AllSkillsView";

export function AllSkillsPage() {
  const search = useSearch({ from: "/markyt/skills" });
  return <AllSkillsView search={search} />;
}
